export default {
    // StepinVconsole17.vue
    "Participants": "Participants",
    "Closed": "Cloturé",
    "No participant yet": "Pas encore de participant",
    "Reject": "Rejeter",
    "Start chat": "Démarrer le chat",
    "Close": "Cloturer",
    "No chat opened": "Aucun chat ouvert",

    // stepin.player.vrun.component.html
    "This session is closed": "Cette session est fermée",
    "Thank you for your participation !": "Merci pour votre participation !",
    "Your request has been rejected": "Votre demande a été rejetée"
}